// extracted by mini-css-extract-plugin
module.exports = {"container":"Close_container__1v2qG"};